import React, { useEffect, useRef } from 'react';

export function useOuterClick(callback) {
  const callbackRef = useRef();
  const innerRef = useRef();
  useEffect(() => { callbackRef.current = callback; });
  useEffect(() => {
      document.addEventListener("click", handleClick);
      return () => document.removeEventListener("click", handleClick);
      function handleClick(e) {
        if (innerRef.current && callbackRef.current && 
            !innerRef.current.contains(e.target) &&
            !overlayIsOpen()
        ) callbackRef.current(e);
      }
  }, []);
      
  return innerRef;
}

function overlayIsOpen() {
  var overlayElement = document.getElementsByClassName('bp3-overlay-open');
  return overlayElement[0] !== undefined;
}